import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import { useState, useEffect, useRef } from 'react';
import { Auth, SignOut, ListGroups } from '../functions/ZIA';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { SendVerificationCode, VerifyCode } from '../functions/Verification';
import Cookies from 'js-cookie';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import ZIATab from './tabs/ZIA';
import DisasterRecoveryTab from './tabs/ZPA';
import ZPATab from './tabs/ZPA';
export const groups_object = { "Rheintec": [], "Helvetia": [], "Credaris": [], "Camion": [] }

function OptionTabs() {

    const [groups, setGroups] = useState({ 'Rheintec': [], 'Helvetia': [], 'Credaris': [], 'Camion': [] });
    const [verified, setVerified] = useState(false)
    const [showVerifyWindow, setShowVerifyWindow] = useState(false);
    const [verifyOperation, setVerifyOperation] = useState("")
    const [verificationKey, setVerificationKey] = useState("")
    const [verificationCode, setVerificationCode] = useState("")
    const [isVerifying, setIsVerifying] = useState(false)
    const [verificationAttempts, setVerificationAttempts] = useState(1)
    const [selectedTab, setSelectedTab] = useState("addToGroup")
    const [ZIASelectedTab, setZIASelectedTab] = useState("addToGroup")
    const [ZPASelectedTab, setZPASelectedTab] = useState("disasterRecovery")
    const handleClose = () => setShowVerifyWindow(false);

    function onTabSelect(eventKey) {
        if (eventKey === "ZIA") {
            setSelectedTab(ZIASelectedTab);
        }
        else if (eventKey === "ZPA") {
            setSelectedTab(ZPASelectedTab);
        }
    }
    async function sendVerificationCode() {
        setVerificationAttempts(1)
        try {
            if (verifyOperation === "") {
                throw new Error("Failed to get verification message")
            }
            const response = await SendVerificationCode(verifyOperation)
            if (response.status === 200) {
                const json = await response.json()
                const fetchedKey = json.key
                setVerificationKey(fetchedKey)
            }
            else {
                const json = await response.json()
                console.log(JSON.stringify(json))

                throw new Error(json.message);
            }
        } catch (error) {
            console.log(error)
            setShowVerifyWindow(false)
            alert("Send verification code failed: " + error.message)
        }

    }

    async function checkVerificationCode() {
        setVerificationAttempts((prev) => ++prev)
        try {
            setIsVerifying(true);
            const response = await VerifyCode(verificationKey, verificationCode)
            if (response.status === 200) {
                setVerified(true)
            }
            else {
                const json = await response.json();
                const message = json.message;
                throw new Error(message);
            }
        } catch (error) {
            alert("Failed to verify: " + error.message)
        } finally {
            setIsVerifying(false)
        }
    }
    const sleep = ms => new Promise(r => setTimeout(r, ms));

    async function getGroups() {
        let newGroups = { ...groups };
        try {
            for (let tenant in groups) {
                const json_session = await Auth(tenant);
                const session = json_session.session;
                const response = await ListGroups(session, tenant);
                const json = await response.json();
                newGroups[tenant] = json.groups
                setGroups({ ...newGroups });
                console.log(newGroups)
                SignOut(session, tenant);
            }
        }
        catch (error) {
            console.log(error)
        }



    }


    useEffect(() => {
        setVerified(false)
        setVerificationCode("")
        setVerificationKey("")
        if (showVerifyWindow) {
            sendVerificationCode()
        }
        else {
            setVerifyOperation("")
        }
    }, [showVerifyWindow])

    useEffect(() => {
        console.log(verifyOperation)
    }, [verifyOperation])
    useEffect(() => {
        console.log(selectedTab)
        const fetchData = async () => {
            const data = await getGroups();
        }
        fetchData()
    }, [])

    useEffect(() => {
        if (verified) {
            setShowVerifyWindow(false)
        }
    }, [verified])

    useEffect(() => {
        if (verificationAttempts > 3) {
            sendVerificationCode();
        }
    }, [verificationAttempts])


    useEffect(() => {
        console.log(selectedTab)
    }, [selectedTab])
    return (
        <>
            <Modal show={showVerifyWindow} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Email Verification Required</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <h5>Please check the details of the operation:</h5>
                    <pre>{typeof verifyOperation === 'string' ? verifyOperation : "Error"}</pre>
                    <Form>

                        <Form.Label htmlFor="verificationCodeField">Code</Form.Label>
                        <Form.Control
                            type="text"
                            value={verificationCode}
                            onChange={(field) => setVerificationCode(field.target.value)}
                            id="verificationCodeField"
                            aria-describedby="verificationCodeFieldHelp"
                            disabled={isVerifying}
                        />
                        <Form.Text id="verificationCodeFieldHelp" muted>
                            You will recieve a code by email after an admin approves your request. Please do not close this window.
                        </Form.Text>
                    </Form>

                </Modal.Body>
                <Modal.Footer>
                    <Button disabled={isVerifying} className='text-light' variant="primary" onClick={sendVerificationCode}>
                        Resend verification code
                    </Button>
                    <Button disabled={isVerifying} className='text-light' variant="success" onClick={checkVerificationCode}>
                        {isVerifying ? <Spinner
                            variant='light'
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                        /> : `Verify(${verificationAttempts}/3)`}
                    </Button>
                </Modal.Footer>
            </Modal>
            <div className='px-3 mt-4 w-100'>
                <Tab.Container id="main-tab" defaultActiveKey="ZIA">
                    <Nav justify variant="tabs" className=' bg-dark-subtle justify-content-center rounded-2' onSelect={(eventKey) => onTabSelect(eventKey)}>
                        <Nav.Item>
                            <Nav.Link eventKey="ZIA">ZIA</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="ZPA">ZPA</Nav.Link>
                        </Nav.Item>
                    </Nav>
                    <Tab.Content>
                        <Tab.Pane eventKey="ZIA">
                            <ZIATab groups={groups} verified={verified} showVerifyWindow={showVerifyWindow} setShowVerifyWindow={setShowVerifyWindow} setVerifyOperation={setVerifyOperation} setVerified={setVerified} setSelectedTab={setSelectedTab} selectedTab={selectedTab} setZIASelectedTab={setZIASelectedTab} />
                        </Tab.Pane>
                        <Tab.Pane eventKey="ZPA">
                            <ZPATab groups={groups} verified={verified} showVerifyWindow={showVerifyWindow} setShowVerifyWindow={setShowVerifyWindow} setVerifyOperation={setVerifyOperation} setVerified={setVerified} setSelectedTab={setSelectedTab} selectedTab={selectedTab} setZPASelectedTab={setZPASelectedTab} />
                        </Tab.Pane>

                    </Tab.Content>
                </Tab.Container>


            </div>
        </>



    );
}

export default OptionTabs;